module.exports = __webpack_public_path__ + "img/default-avatar.0265a5a6.svg";